import { SnackbarProvider } from 'notistack';
import { CssBaseline } from '@mui/material';
import {
  QueryClient, QueryClientProvider, QueryCache, MutationCache
} from '@tanstack/react-query';
import { CookiesProvider } from 'react-cookie';
import { ErrorBoundary } from 'react-error-boundary';
import AppContainer from 'components/AppContainer';
import ThemeProvider from 'components/ThemeProvider';
import Routes from 'routes/Routes';
import ErrorPage from 'pages/Error/Error';
import 'i18n/config';

const reload = (error, query) => {
  if (error.error === 'authentication' && !query.queryKey?.includes('state')) {
    window.location.reload();
  }
};

const queryClient =  new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      keepPreviousData: false,
      retry: false
    }
  },
  mutationCache: new MutationCache({
    onError: reload
  }),
  queryCache: new QueryCache({
    onError: reload
  })
});

const App = () => (
  <CookiesProvider>
    <ThemeProvider>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        variant="success"
        preventDuplicate
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary FallbackComponent={ErrorPage}>
            <AppContainer>
              <Routes />
            </AppContainer>
          </ErrorBoundary>
        </QueryClientProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </CookiesProvider>
);

export default App;
